import React, { useState ,useEffect, useRef, useMemo, useCallback } from 'react'
import CommonTablePage, { CommonTablePagePropsInterface } from '../../../components/common/common-table/common-table-page'
import { urlKey } from '../../../services/api/api-urls'
import SalesOrderManagementColumnModel from '../sales-order/sales-order-management-column-model'
import SweetAlertService from '../../../services/lib/utils/sweet-alert-service'
import { ApiRequest } from '../../../services/api/api'
import CommonDialog from '../../../components/common/others/common-dialog'
import SalesOrderProductManagementDialog from '../sales-order/sales-order-product-management-dialog/sales-order-product-management-dialog'
import moment, { months } from 'moment'
import { Button, DatePicker } from 'antd'
import { useParams } from 'react-router-dom'
import { getCookie } from 'react-use-cookie'
import { useLocation } from 'react-router-dom';
import Iselect from '../../../components/common/i-select'
import { getAllProductRequest } from '../../../services/others/warehouse-management-services'
import { getEmployeeRequest } from '../../../services/others/work-arrangement-services'
import { ColDef, ExcelRow, GridReadyEvent } from 'ag-grid-community'
import { AgGridReact } from 'ag-grid-react'
import 'ag-grid-enterprise'
// import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-alpine.css'
import { useDocumentTitle } from '../../../services/title/useDocumentTitle'

const { RangePicker } = DatePicker

const baseGetUrl = 'Invoice/GetNewSaleReport'
const NewSalesReportPage = (props: { customerId: any }) => {
  // this is using for export excel file
  // const _exporter = React.createRef<ExcelExport>()
  const gridRef = useRef<AgGridReact<any>>(null)

  const [triggerResetData, setTriggerResetData] = useState(false)
  // const [dialogTitle, setDialogTitle] = useState<string>()
//   const [open, setOpen] = useState(false)
//   const [orderData, setOrderData] = useState(false)
//   const [sales, setSales] = useState<any>()
//   const [profit, setProfit] = useState<any>()
//   const [deliveryFee, setDeliveryFee] = useState<any>()
//   const [urgentFee, setUrgentFee] = useState<any>()
//   const [setupFee, setSetupFee] = useState<any>()

  const [invoiceData, setInvoiceData] = useState<any>()
  const [dataExportBy, setDataExportrBy] = useState<any>([])
  const [selectExportBy, setSelectExportBy] = useState<'product' | 'sale' | 'customer'>()
  const [productList, setProductList] = useState<any[]>([])
  const [selectedProduct, setSelectedProduct] = useState<number>()
  const [customerList, setCustomerList] = useState<any[]>([])
  const [selectedCustomer, setSelectedCustomer] = useState<number>()
  const [employeeList, setEmployeeList] = useState<any[]>([])
  const [selectedEmployee, setSelectedEmployee] = useState<number>()
  const [startDate, setStartDate] = useState<string>('')
  const [endDate, setEndDate] = useState<string>('')
  const [exportedData, setExportedData] = useState<any[]>([])
  const [columnDefs, setColumnDefs] = useState<ColDef[]>([
    { field: 'productCode', width: 120 },
    { field: 'productOrOptionName', width: 200 },
    { field: 'packageQty' },
    { field: 'numberQuantity' },
    { field: 'totalQty' },
    { field: 'unitPrice' },
    { field: 'totalPrice' },
    { field: 'profitRate' },
    { field: 'reservePrice' },
    { field: 'reserveTotalPrice' },
  ])
  const defaultColDef = useMemo<ColDef>(() => {
    return {
      // sortable: false,
      // filter: false,
      // resizable: false,
      // minWidth: 50,
      // flex: 1,
    }
  }, [])
  const popupParent = useMemo<HTMLElement>(() => {
    return document.body
  }, [])
  const onGridReady = useCallback((params: GridReadyEvent) => {}, [])

  const {id}:any  = useParams()
  const location = useLocation();
  let getUrlemployeePara = id == '1' ? '&employeeId=' + parseInt(getCookie('id')) : ''
  const [url, setUrl] = useState<string>(baseGetUrl + '?start='
        + moment().add(1, 'months').format('YYYY/MM/DD')
        + '&end=' + moment().add(1, 'days').format('YYYY/MM/DD'))


  useEffect(() => {
    setDataExportrBy([{label: 'By Product', value: 'product'}, {label: 'By Customer', value: 'customer'}, {label: 'By Sale', value: 'sale'}])
    getAllProductRequest()
      .then(res => {
        const selectArray: any[] = []
        res.data.data.forEach((product:any) => selectArray.push(
          {
            value: product.productId,
            label: product.productName
          }
        ))
        setProductList(selectArray)
      })
    ApiRequest({url: 'Customer/GetAllCustomer', method: 'get'})
      .then(res => {
        const selectArray = res.data.data.map((customer: any) => ({
          label: customer.company + ' / ' + customer.customerCode,
          value: customer.customerId
        }))
        setCustomerList(selectArray)
      })
    getEmployeeRequest()
      .then((res) => {
        const selectArray = res.data.data.map((employee: any) => ({
          label: employee.firstName + ' / ' + employee.lastName,
          value: employee.employeeId
        }))
        setEmployeeList(selectArray)
      })
    console.log('Location changed',location);
    console.log('Location changed',id);
    getUrlemployeePara = id == '1' ? '&employeeId=' + parseInt(getCookie('id')) : ''
    const url = baseGetUrl + '?start='
      + moment().add(1, 'months').format('YYYY/MM/DD')
      + '&end=' + moment().add(1, 'days').format('YYYY/MM/DD')
      + getUrlemployeePara;
    setUrl(url)
    // id = useParams();
    setTriggerResetData(!triggerResetData)

  }, [location]);
  useDocumentTitle();
  // useEffect(() => {
  //   if (props.customerId) return
  //   else document.title = "Sales Report";
  // }, [])


//   const salesOrderProductManagementDialog = <SalesOrderProductManagementDialog orderData={orderData} isNewOrder={isNewOrder} onDialogClose={onDialogClose} customerId={props.customerId} />

  const setFooter = (data:any) => {
    let setupFee = 0, deliveryFee = 0, sales = 0, profit = 0, urgentFee = 0
    data.map((row: any) => {
      profit = profit + row.profit
      row.invoiceItem.map ((item:any) => {
        if (item.optionId === null) sales = sales + item.totalPrice
        if (item.optionId === 1) deliveryFee = deliveryFee + item.totalPrice
        if (item.optionId === 3) setupFee = setupFee + item.totalPrice
        if (item.optionId === 2) urgentFee = urgentFee + item.totalPrice
      })
    })
    // setDeliveryFee(deliveryFee.toFixed(2))
    // setSales(sales.toFixed(2))
    // setSetupFee(setupFee.toFixed(2))
    // setProfit(profit.toFixed(2))
    // setUrgentFee(urgentFee.toFixed(2))
  }
  const getRenderData = (data: any) => {
    let renderData: any = []
    renderData = data
    console.log('getRenderData - First item:', data[0])
    console.log('getRenderData - All keys:', Object.keys(data[0] || {}))
    console.log('getRenderData - productCode value:', data[0]?.productCode)

    // const strucData = renderData.map((item: any) => {
    //   return {...item,
    //     totalQty: item.packageQty * item.quantity,
    //     totalWholePrice: item.unitPrice * item.quantity
    //   }
    // })

    const groupedData = groupData(renderData, 'productOrOptionName')
    const exportedArrayData: any[] = []
    for (const key in groupedData) {
      const items = groupedData[key]
      const result: any[] = []
      const reservePrices = Array.from(new Set(items.map((item: any) => item.reservePrice)))
      const unitPrices = Array.from(new Set(items.map((item: any) => item.unitPrice)))

      reservePrices.forEach((reservePrice: any) => {
        unitPrices.forEach((unitPrice: any) => {
          const dataToCal = items.filter((item: any) => item.unitPrice === unitPrice && item.reservePrice === reservePrice)
          if (dataToCal.length !== 0) {
            let totalQtyAll = 0
            let totalPriceAll = 0
            let totalReservePriceAll = 0
            dataToCal.forEach((item: any) => {
              totalQtyAll += item.quantity
              totalPriceAll += (item.totalPrice.toFixed(2) * 100)
              totalReservePriceAll += (item.reserveTotalPrice.toFixed(2) * 100)
            })

            const data = {...dataToCal[0], numberQuantity: dataToCal.length, totalPrice: totalPriceAll / 100, totalQty: totalQtyAll, reserveTotalPrice: totalReservePriceAll / 100}
            // Ensure productCode is preserved
            if (dataToCal[0]?.productCode) {
              data.productCode = dataToCal[0].productCode
            }
            result.push(data)
          }
        })
      })
      exportedArrayData.push(result)
    }

    const finalData = exportedArrayData.flat().sort((a: any, b: any) => a.optionId - b.optionId)

    finalData.forEach((item: any) => {
      item.profitRate = item.reservePrice === 0 ? null : Number(((item.unitPrice - item.reservePrice) / item.reservePrice).toFixed(2))
    })

    setExportedData(finalData)
    console.log(finalData)

    return finalData
  }

  const onChange = (date:any, dateString:any) => {
    console.log('date', date, dateString)
    setStartDate(dateString[0])
    setEndDate(dateString[1])
  }
  const actionButtons: any = [

  ]

  const onFilterChange = (tableRef: any) => {
    setFooter(tableRef.current.dataManager.searchedData)
  }

  // const onSearchChange = (tableRef: any) => {
  //   setFooter(tableRef.current.dataManager.searchedData)
  // }

  const onSelectDataExportrBy = (value: any) => {
    setSelectExportBy(value)
    switch (value) {
      case 'product':
        setSelectedCustomer(undefined)
        setSelectedEmployee(undefined)
        break
      case 'customer':
        setSelectedProduct(undefined)
        setSelectedEmployee(undefined)
        break
      case 'sale':
        setSelectedCustomer(undefined)
        setSelectedProduct(undefined)
        break
    }
  }

  const onSelectProduct = (value: number) => {
    setSelectedProduct(value)
  }

  const onSelectCustomer = (value: number) => {
    setSelectedCustomer(value)
  }

  const onSelectEmployee = (value: number) => {
    setSelectedEmployee(value)
  }

  const onConfirm = () => {
    let exportString = ''
    switch (selectExportBy) {
      case 'product':
        exportString = '&productId=' + selectedProduct
        break
      case 'customer':
        exportString = '&customerId=' + selectedCustomer
        break
      case 'sale':
        exportString = '&salesId=' + selectedEmployee
        break
      default:
        break
    }
    const url = baseGetUrl + '?start=' + startDate + '&end=' + endDate + exportString + getUrlemployeePara
    setUrl(url)
    setTriggerResetData(!triggerResetData)
  }

  const groupData = (arr: any, property: any) => {
    const data = arr.reduce((group: any, item: any) => {
      const pro = item[property]
      group[pro] = group[pro] ?? []
      group[pro].push(item)
      return group
    }, {})
    return data
  }

  const dateToYMD = (date: Date) => {
    const strArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    const d = date.getDate()
    const m = strArray[date.getMonth()]
    const y = date.getFullYear()
    return '' + (d <= 9 ? '0' + d : d) + ' ' + m + ' ' + y
  }

  const getHeader = (): ExcelRow[] => {
    let exportBy = ''
    let exportName = ''
    switch (selectExportBy) {
      case 'customer':
        exportBy = 'Customer'
        exportName = customerList?.filter((item: any) => item.value === selectedCustomer)[0].label
        break
      case 'product':
        exportBy = 'Product'
        exportName = productList?.filter((item: any) => item.value === selectedProduct)[0].label
        break
      case 'sale':
        exportBy = 'Sales'
        exportName = employeeList?.filter((item: any) => item.value === selectedEmployee)[0].label
        break
      default:
        break
    }
    const startStr = dateToYMD(new Date(startDate))
    const endStr = dateToYMD(new Date(endDate))
    return [
      {
        cells: [
          { data: { value: 'JADCUP - Order Summary by ' + exportBy, type: 'String' }, mergeAcross: 8},
        ],
      },
      { cells: [] },
      {
        cells: [
          { data: { value: exportName, type: 'String' }, mergeAcross: 8},
        ],
      },
      {
        cells: [
          { data: { value: startStr + ' to ' + endStr, type: 'String' }, mergeAcross: 8},
        ],
      },
      { cells: [] },
    ]
  }

  const getFooter = (): ExcelRow[] => {
    const noReturnItems = exportedData.filter((item: any) => item.productOrOptionName !== 'Return')
    const returnItems = exportedData.filter((item: any) => item.productOrOptionName === 'Return')
    const subTotalWithoutRe = noReturnItems?.reduce((acc: number, item: any) => (acc + item.totalPrice.toFixed(2) * 100), 0) / 100
    const returnTotal = returnItems?.reduce((acc: number, item: any) => (acc + item.totalPrice.toFixed(2) * 100), 0) / 100
    const subTotal: number = exportedData?.reduce((acc: number, item: any) => (acc + item.totalPrice.toFixed(2) * 100), 0) / 100
    const gst = subTotal * 0.15
    const totalReserve = exportedData?.reduce((acc: number, item: any) => (acc + item.reserveTotalPrice.toFixed(2) * 100)) / 100
    return [
      { cells: [] },
      {
        cells: [
          { data: { value: '', type: 'String'}},
          { data: { value: '', type: 'String'}},
          { data: { value: '', type: 'String'}},
          { data: { value: '', type: 'String'}},
          { data: { value: 'Summary', type: 'String'}, mergeAcross: 1},
          { data: { value: '', type: 'String'}},
          { data: { value: 'Profit Summary', type: 'String'}, mergeAcross: 1},
        ],
      },
      { cells: [] },
      {
        cells: [
          { data: { value: '', type: 'String'}},
          { data: { value: '', type: 'String'}},
          { data: { value: '', type: 'String'}},
          { data: { value: '', type: 'String'}},
          { data: { value: 'Subtotal: ', type: 'String'}},
          { data: { value: '$' + subTotalWithoutRe, type: 'String'}},
          { data: { value: '', type: 'String'}},
          { data: { value: 'Net Sales: ', type: 'String'}},
          { data: { value: '$' + subTotal, type: 'String'}},
        ],
      },
      {
        cells: [
          { data: { value: '', type: 'String'}},
          { data: { value: '', type: 'String'}},
          { data: { value: '', type: 'String'}},
          { data: { value: '', type: 'String'}},
          { data: { value: 'Return: ', type: 'String'}},
          { data: { value: '-$' + Math.abs(returnTotal), type: 'String'}},
          { data: { value: '', type: 'String'}},
          { data: { value: 'Total Reserve: ', type: 'String'}},
          { data: { value: '$' + totalReserve, type: 'String'}},
        ],
      },
      {
        cells: [
          { data: { value: '', type: 'String'}},
          { data: { value: '', type: 'String'}},
          { data: { value: '', type: 'String'}},
          { data: { value: '', type: 'String'}},
          { data: { value: 'GST: ', type: 'String'}},
          { data: { value: '$' + gst.toFixed(2), type: 'String'}},
        ],
      },
      {
        cells: [
          { data: { value: '', type: 'String'}},
          { data: { value: '', type: 'String'}},
          { data: { value: '', type: 'String'}},
          { data: { value: '', type: 'String'}},
          { data: { value: 'Total: ', type: 'String'}},
          { data: { value: '$' + (subTotal + gst).toFixed(2), type: 'String'}},
          { data: { value: '', type: 'String'}},
          { data: { value: 'Net Profit: ', type: 'String'}},
          { data: { value: '$' + (subTotal - totalReserve), type: 'String'}},
        ],
      },
    ]
  }

  const onExportExcel = useCallback(() => {
    if (exportedData.length === 0) {
      SweetAlertService.errorMessage('No data to export');
      return;
    }

    try {
      const dataToExport = exportedData;
      
    // 计算汇总数据
    const noReturnItems = dataToExport.filter((item: any) => item.productOrOptionName !== 'Return');
    const returnItems = dataToExport.filter((item: any) => item.productOrOptionName === 'Return');
    
    const subTotalWithoutRe = noReturnItems?.reduce((acc: number, item: any) => (acc + (item.totalPrice || 0)), 0);
    const returnTotal = returnItems?.reduce((acc: number, item: any) => (acc + (item.totalPrice || 0)), 0);
    const subTotal = dataToExport?.reduce((acc: number, item: any) => (acc + (item.totalPrice || 0)), 0);
    const totalReserve = dataToExport?.reduce((acc: number, item: any) => (acc + (item.reserveTotalPrice || 0)), 0);
    const gst = subTotal * 0.15;
    const netProfit = subTotal - totalReserve;

    // 统一的列名
      const headers = [
        'Product Code',
        'Description',
        'Units per Pack',
        'Total Pack',
        'Total Units',
        'Price Per Pack',
        'Total Amount',
        'Profit Rate',
        'Reserve Price',
        'Total'
      ];

      // 格式化函数
      const formatCellValue = (value: any) => {
        if (value === null || value === undefined) return '';
        const stringValue = String(value);
        if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
          return `"${stringValue.replace(/"/g, '""')}"`;
        }
        return stringValue;
      };

      const formatCurrency = (value: any) => {
        if (value === null || value === undefined) return '0.00';
        return parseFloat(value).toFixed(2);
      };

      // 构建 CSV 内容
      const csvRows = [];

      // 添加表头
      csvRows.push(headers.join(','));

      // 添加数据行 - 根据你的数据结构映射到统一的列名
      dataToExport.forEach(row => {
        const rowData = [
          formatCellValue(row.productCode || ''), // Product Code
          formatCellValue(row.productOrOptionName || row.description), // Description
          formatCellValue(row.unitsPerPack || row.packageQty), // Units per Pack
          formatCellValue(row.totalPack || row.numberQuantity), // Total Pack
          formatCellValue(row.totalUnits || row.totalQty), // Total Units
          formatCurrency(row.pricePerPack || row.unitPrice), // Price Per Pack
          formatCurrency(row.totalAmount || row.totalPrice), // Total Amount
          row.profitRate ? `${(row.profitRate * 100).toFixed(2)}%` : '0.00%', // Profit Rate
          formatCurrency(row.reservePrice), // Reserve Price
          formatCurrency(row.total || row.reserveTotalPrice) // Total
        ];
        csvRows.push(rowData.join(','));
      });
      // 添加空行
      csvRows.push('');
      csvRows.push('');

      // 添加 Summary 部分
      csvRows.push(',,,,Summary,,Profit Summary,');
      csvRows.push('');
      csvRows.push(`,,,,Subtotal:,$${formatCurrency(subTotalWithoutRe)},,Net Sales:,$${formatCurrency(subTotal)}`);
      csvRows.push(`,,,,Return:,-$${formatCurrency(Math.abs(returnTotal))},,Total Reserve:,$${formatCurrency(totalReserve)}`);
      csvRows.push(`,,,,GST:,$${formatCurrency(gst)},,`);
      csvRows.push(`,,,,Total:,$${formatCurrency(subTotal + gst)},,Net Profit:,$${formatCurrency(netProfit)}`);
      const csvContent = csvRows.join('\n');

      // 创建并下载文件
      const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      
      link.setAttribute('href', url);
      link.setAttribute('download', `sales_report_${moment().format('YYYY-MM-DD_HH-mm-ss')}.csv`);
      link.style.visibility = 'hidden';
      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // 清理
      setTimeout(() => URL.revokeObjectURL(url), 100);

      SweetAlertService.successMessage('Export completed successfully!');

    } catch (error:any) {
      console.error('Export failed:', error);
      SweetAlertService.errorMessage(`Export failed: ${error.message}`);
    }
  }, [exportedData]);

  const getReportColumns = () => {
    const productCodeColumn = { title: 'Product Code', field: 'productCode', render: (rowData: any) => rowData.productCode || '-' };
    const allColumns = SalesOrderManagementColumnModel('newInvoice') as any[];
    const filteredColumns = allColumns
      .filter((row: any) => !['Delivery Method', 'Stage', 'Account Note'].includes(row.title))
      .map((row: any) => (row.title === 'Paid' ? { ...row, defaultFilter: ['1'] } : row));
    return [productCodeColumn, ...filteredColumns];
  };

  const commonTablePageProps: CommonTablePagePropsInterface = {
    urlInfoKey: urlKey.Invoice,
    getAllUrl: url,
    title: 'Sales Report',
    column: getReportColumns(),
    mappingRenderData: (data: any) => getRenderData(data),
    mappingUpdateData: (dataDetail: any) => {
      dataDetail.draft = parseInt(dataDetail.draft, 10)
      return dataDetail
    },
    triggerResetData: triggerResetData,
    actionButtons: actionButtons,
    onFilterChange: onFilterChange,
    isNotAddable: true,
    isNotEditable: true,
    isNotDeletable: true
  }
  return (
    <div style={{position: 'relative'}}>
      <div style={{position: 'absolute', top: '20px', left: '200px', zIndex: 10}}>
        <RangePicker onChange={onChange}/>
      </div>
      <div style={{position: 'absolute', top: '20px', left: '500px', zIndex: 10}}>
        Export By: &nbsp;<Iselect onChange={onSelectDataExportrBy} data={dataExportBy} width={200} value={''} placeholder={'Select Export By'}/>
      </div>
      {selectExportBy === 'product' &&
        <div style={{position: 'absolute', top: '20px', left: '800px', zIndex: 10}}>
          Product: &nbsp;<Iselect onChange={onSelectProduct} data={productList} width={300} value={''} placeholder={'Select Product'}/>
        </div>
      }
      {selectExportBy === 'customer' &&
        <div style={{position: 'absolute', top: '20px', left: '800px', zIndex: 10}}>
          Customer: &nbsp;<Iselect onChange={onSelectCustomer} data={customerList} width={300} value={''} placeholder={'Select Customer'}/>
        </div>
      }
      {selectExportBy === 'sale' &&
        <div style={{position: 'absolute', top: '20px', left: '800px', zIndex: 10}}>
          Customer: &nbsp;<Iselect onChange={onSelectEmployee} data={employeeList} width={300} value={''} placeholder={'Select Sale'}/>
        </div>
      }
      <div style={{position: 'absolute', top: '20px', left: '1200px', zIndex: 10}}>
        <Button type='primary' onClick={onConfirm}
          disabled={startDate === undefined || endDate === undefined || selectExportBy === undefined ||
          (selectExportBy === 'product' && selectedProduct === undefined) ||
          (selectExportBy === 'customer' && selectedCustomer === undefined) ||
          (selectExportBy === 'sale' && selectedEmployee === undefined)}>Confirm</Button>
      </div>
      <div style={{position: 'absolute', top: '20px', left: '1300px', zIndex: 10}}>
        <Button type='primary' onClick={onExportExcel} disabled={exportedData.length === 0}>Export Excel</Button>
      </div>
      <CommonTablePage {...commonTablePageProps} />

      {/* <CommonDialog title={dialogTitle} open={open} onDialogClose={onDialogClose} dialogContent={salesOrderProductManagementDialog} /> */}

      <div className="grid-wrapper" style={{opacity: '0',display:'none'}}>
        <div className="ag-theme-alpine">
          <AgGridReact<any>
            ref={gridRef}
            rowData={exportedData}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            popupParent={popupParent}
            onGridReady={onGridReady}
          ></AgGridReact>
        </div>
      </div>
    </div>
  )
}

export default NewSalesReportPage
